"use client";

import { USER_TYPE } from "@/lib/constants";
import { useMapUIStore } from "@/stores/mapUIStore";
import { useUser } from "@/stores/user";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import { BaseSidebarFrame } from "../../components/media-list/BaseSidebarFrame";
import CategoryFloatingButton from "./CategoryFloatingButton";
import MediaLisAdvertiserRole from "./MediaListAdvertiserRole";
import MediaListMediaRole from "./MediaListMediaRole";


export default function MediaListTemplate() {
  const { userInfo } = useUser();
  const [openCategory, setOpenCategory] = useState(false);
  const mode = useMapUIStore((s) => s.mode);
  const openClusterList = useMapUIStore((s) => s.openClusterList);
  const hideSidebar = useMapUIStore((s) => s.hideSidebar);

  const url = usePathname();
  const checkedPath = url.includes("/search/");

  useEffect(() => {
    if (!checkedPath && userInfo?.user?.user_type?.toLocaleLowerCase() === USER_TYPE.advertiser) {
      setOpenCategory(false);
    }
  }, [checkedPath]);

  const isSidebarOpen = mode !== "hidden";
  const SIDEBAR_WIDTH = 395;

  return (
    <>
      {/* Floating Button Wrapper */}
      <div
        className="fixed top-[calc(var(--header-height)+12px)] z-[60] transition-all duration-300"
        style={{
          left: isSidebarOpen ? SIDEBAR_WIDTH + 10 : 10,
        }}
      >
        <CategoryFloatingButton openCategory={openCategory} />
      </div>
      {userInfo?.user?.user_type?.toLocaleLowerCase() === USER_TYPE.media ? (
        <BaseSidebarFrame
          open={isSidebarOpen}
          onToggle={() => (mode === "hidden" ? openClusterList : hideSidebar)()}
          width={395}
        >
          <MediaListMediaRole />
        </BaseSidebarFrame>
      ) : (
        <BaseSidebarFrame
          open={isSidebarOpen}
          onToggle={() => (mode === "hidden" ? openClusterList : hideSidebar)()}
          width={395}
        >
          <MediaLisAdvertiserRole />
        </BaseSidebarFrame>
      )}
    </>
  );
}
